function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import "core-js/modules/es.object.assign.js";
/* eslint-disable no-restricted-globals */

import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useIsWithinBreakpoints } from '../../../../src/services/hooks/useIsWithinBreakpoints';
import { EUI_THEMES } from '../../../../src/themes';
import { ThemeContext } from '../with_theme'; // @ts-ignore Not TS

import { GuideLocaleSelector } from '../guide_locale_selector';
import { EuiText, EuiTourStep, EuiPopover, EuiHorizontalRule, EuiButton, EuiContextMenuPanel, EuiContextMenuItem, EuiLink, EuiIcon } from '../../../../src/components';
export var GuideThemeSelector = function GuideThemeSelector(_ref) {
  var rest = Object.assign({}, _ref);
  return ___EmotionJSX(ThemeContext.Consumer, null, function (context) {
    return ___EmotionJSX(GuideThemeSelectorComponent, _extends({
      context: context
    }, rest));
  });
};
GuideThemeSelector.propTypes = {
  onToggleLocale: PropTypes.func.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  context: PropTypes.any
};
var STORAGE_KEY = 'legacy_theme_notification';

var GuideThemeSelectorComponent = ({
  context,
  onToggleLocale,
  selectedLocale
}) => {
  const isMobileSize = useIsWithinBreakpoints(['xs', 's']);
  const [isPopoverOpen, setPopover] = useState(false);
  const [isOpen, setIsOpen] = useState(localStorage.getItem(STORAGE_KEY) !== 'dismissed');

  const onTourDismiss = () => {
    setIsOpen(false);
    localStorage.setItem(STORAGE_KEY, 'dismissed');
  };

  const onButtonClick = () => {
    setPopover(!isPopoverOpen);
    setIsOpen(false);
    localStorage.setItem(STORAGE_KEY, 'dismissed');
  };

  const closePopover = () => {
    setPopover(false);
  };

  const currentTheme = EUI_THEMES.find(theme => theme.value === context.theme) || EUI_THEMES[0];

  const getIconType = value => {
    return value === currentTheme.value ? 'check' : 'empty';
  };

  const items = EUI_THEMES.map(theme => {
    return <EuiContextMenuItem key={theme.value} icon={getIconType(theme.value)} onClick={() => {
      closePopover();
      context.changeTheme(theme.value);
    }}>
        {theme.text}
      </EuiContextMenuItem>;
  });
  const button = <EuiButton size="s" iconType="arrowDown" iconSide="right" color="ghost" minWidth={0} onClick={onButtonClick}>
      {isMobileSize ? 'Theme' : currentTheme.text}
    </EuiButton>;
  return <EuiTourStep content={<EuiText style={{
    maxWidth: 320
  }}>
          <p>
            Amsterdam is now the only theme and the legacy theme has been
            removed.
          </p>
        </EuiText>} isStepOpen={isOpen} onFinish={onTourDismiss} step={1} stepsTotal={1} title={<>
          <EuiIcon type="bell" size="s" /> &nbsp; Theming update
        </>} footerAction={<EuiLink onClick={onTourDismiss}>Got it!</EuiLink>} repositionOnScroll>
      <EuiPopover id="docsThemeSelector" repositionOnScroll button={button} isOpen={isPopoverOpen} closePopover={closePopover} panelPaddingSize="none" anchorPosition="downRight">
        <EuiContextMenuPanel size="s" items={items} />
        {location.host.includes('803') && <>
            <EuiHorizontalRule margin="none" />
            <div style={{
          padding: 8
        }}>
              <GuideLocaleSelector onToggleLocale={onToggleLocale} selectedLocale={selectedLocale} />
            </div>
          </>}
      </EuiPopover>
    </EuiTourStep>;
};

GuideThemeSelectorComponent.propTypes = {
  onToggleLocale: PropTypes.func.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  context: PropTypes.any
};